import React from 'react';
import { compose } from 'redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { ALL_FOLDER_ID } from '@wix/da-url';
import shortenNumber from '@wix/da-shared-react/pkg/utils/shortenNumber';
import SortOrderSwitcher from '../SortOrderSwitcher';
import FolderDropdown from '../FolderDropdown';
import { getStickyContentHeight } from '../../helpers';
import {
  getGallectionsStickyBarHeight,
  getCommentsBlockAnchor,
} from '../helpers';
import { PapiGallection } from '@wix/da-types-papi';
import {
  withPerspectiveContext,
  PerspectiveContextProps,
  withMobileContext,
  WithMobileContextProps,
} from '@wix/da-shared-react/pkg/Context';
import EditGallectionButton from '../EditGallectionButton';

import s from './FolderBar.scss';

export interface Props {
  currentlyViewedFolder: PapiGallection | null;
  unsetSelectedFolderId: () => void;
  pauseCurrentFolderDeviationFetching: () => void;
  withBackButton?: boolean;
}

const enhance = compose(
  withPerspectiveContext,
  withMobileContext,
  withTranslation()
);

class FolderBar extends React.PureComponent<
  Props & WithTranslation & PerspectiveContextProps & WithMobileContextProps
> {
  render() {
    const {
      withBackButton,
      currentlyViewedFolder,
      unsetSelectedFolderId,
      t,
    } = this.props;

    const vespaSearchEngineIsReady = false;

    if (!currentlyViewedFolder) {
      return null;
    }

    return (
      <>
        <div className={s['folder-info']}>
          {withBackButton && (
            <div className={s['back']} onClick={unsetSelectedFolderId}>
              {t!('pages.gallections.back')}
            </div>
          )}
          <FolderDropdown />
          <a
            className={s['comments-count']}
            href={'#' + getCommentsBlockAnchor(currentlyViewedFolder.folderId)}
            onClick={this.onCommentLinkClick}
          >
            {t!('common.comments_plural')}
            <span className={s['count']}>
              {shortenNumber(currentlyViewedFolder.commentCount)}
            </span>
          </a>
        </div>
        <div className={s['right-zone']}>
          {vespaSearchEngineIsReady && (
            <SortOrderSwitcher className={s['sort-order-switch']} />
          )}
          {currentlyViewedFolder!.folderId !== ALL_FOLDER_ID && (
            <EditGallectionButton gallection={currentlyViewedFolder} />
          )}
        </div>
      </>
    );
  }

  onCommentLinkClick = e => {
    e.preventDefault();

    this.props.pauseCurrentFolderDeviationFetching();
    this.scrollToCommentBlock();
  };

  scrollToCommentBlock = () => {
    const {
      isMobile,
      currentlyViewedFolder,
      getScrollableContainer,
    } = this.props;

    const commentBlockNode = document.getElementById(
      getCommentsBlockAnchor(currentlyViewedFolder!.folderId)
    );
    if (!commentBlockNode) {
      return;
    }

    const offsetTop =
      getStickyContentHeight(isMobile) +
      getGallectionsStickyBarHeight(isMobile);

    const scrollableContainer = getScrollableContainer();

    scrollableContainer &&
      scrollableContainer.scrollTo(
        0,
        scrollableContainer.scrollTop +
          commentBlockNode.getBoundingClientRect().top -
          offsetTop
      );
  };
}

export default enhance(FolderBar) as React.ComponentType<Props>;
